import { apiGet, apiPost, apiRequestBase } from "./client";
import { env } from "../config/env";

export const posApi = {
  // Barcode templates
  getBarcodeTemplates: (payload: unknown) =>
    apiPost("/BarcodeTemplate/GetTemplates", payload),
  createBarcodeTemplate: (payload: unknown) =>
    apiPost("/BarcodeTemplate/create", payload),
  updateBarcodeTemplate: (payload: unknown) =>
    apiPost("/BarcodeTemplate/update", payload),
  deleteBarcodeTemplate: (id: number) => apiPost("/BarcodeTemplate/delete", id),
  getBarcodeTemplateById: (id: number) =>
    apiGet(`/BarcodeTemplate/details?id=${id}`),

  // POS counter sessions
  checkInCounter: (payload: unknown) =>
    apiPost("/PosCashRegister/Checkin", payload),
  checkOutCounter: (payload: unknown) =>
    apiPost("/PosCashRegister/Checkout", payload),
  getLastCounterSession: (counterId: number) =>
    apiGet(`/PosCashRegister/GetLastCounterSessionInfo?CounterId=${counterId}`),
  getCounterSessionInfo: (id: number) =>
    apiGet(`/PosCashRegister/counterSessionInfo?id=${id}`),
  getCounterSessions: (payload: unknown) =>
    apiPost("/PosCashRegister/GetCounterSessions", payload),
  verifyCounterSession: (payload: unknown) =>
    apiPost("/PosCashRegister/SessionVerify", payload),
  getCounterSelectList: () => apiGet("/PosCashRegister/selectList"),

  // POS counters
  getCounters: (payload?: unknown) =>
    apiPost("/salescounter/getall", payload ?? {}),
  createCounter: (payload: unknown) =>
    apiPost("/salescounter/create", payload),
  updateCounter: (payload: unknown) =>
    apiPost("/salescounter/update", payload),
  deleteCounter: (id: number) => apiPost("/salescounter/delete", id),
  getCounterById: (id: number) => apiGet(`/salescounter/details?id=${id}`),
  anyCounterIsActive: (outletId: number) =>
    apiGet(`/salescounter/anyCounterIsActive?OutletId=${outletId}`),
  changeCounterActiveStatus: (payload: unknown) =>
    apiPost("/salescounter/ChangeActiveStatus", payload),

  // Cash movements
  createCashMovement: (payload: unknown) =>
    apiPost("/SalesCounter/CreateCashMovement", payload),
  getAllCashMovements: (counterSessionId: number) =>
    apiGet(`/SalesCounter/GetAllCashMovements?CounterSessionId=${counterSessionId}`),

  // POS orders
  getPosOrders: () => apiGet("/posorder/getposorders"),
  getPosOrdersServerSide: (payload: unknown) =>
    apiPost("/posorder/getposorders", payload),
  createPosOrder: (payload: unknown) =>
    apiPost("/posorder/create", payload),
  updatePosOrder: (payload: unknown) =>
    apiPost("/posorder/update", payload),
  deletePosOrder: (id: number) => apiPost("/posorder/delete", id),
  getPosOrderById: (id: number) => apiGet(`/posorder/details?id=${id}`),

  // POS outlet sessions
  checkInOutlet: (payload: unknown) =>
    apiPost("/OutletSession/Checkin", payload),
  checkOutOutlet: (payload: unknown) =>
    apiPost("/OutletSession/Checkout", payload),
  getLastOutletSession: (outletId: number) =>
    apiGet(`/OutletSession/GetLastSessionInfo?OutletId=${outletId}`),
  getOutletSessionInfo: (id: number) =>
    apiGet(`/OutletSession/getSessionInfo?id=${id}`),
  addCounterOpeningBalance: (payload: unknown) =>
    apiPost("/OutletSession/AddCounterOpeningBalance", payload),
  getOutletSessions: (payload: unknown) =>
    apiPost("/OutletSession/GetOutletSessions", payload),
  getOutletSelectList: () => apiGet("/OutletSession/selectList"),

  // POS outlets
  getOutlets: (payload: { isActive: boolean | null }) =>
    apiPost("/Outlet/GetAll", payload),
  createOutlet: (payload: unknown) => apiPost("/Outlet/Create", payload),
  updateOutlet: (payload: unknown) => apiPost("/Outlet/Update", payload),
  getOutletById: (id: number) => apiGet(`/Outlet/Details?id=${id}`),
  changeOutletStatus: (payload: unknown) =>
    apiPost("/Outlet/changeActiveStatus", payload),

  // POS outlet access
  createOutletAccess: (payload: unknown) =>
    apiPost("/OutletUserAccess/Create", payload),
  removeOutletAccess: (payload: unknown) =>
    apiPost("/OutletUserAccess/RemoveAccess", payload),
  getOutletAccess: (payload: unknown) =>
    apiPost("/OutletUserAccess/Getall", payload),

  // POS returns
  createPosReturn: (payload: unknown) =>
    apiPost("/PosReturn/Create", payload),
  getPosReturnById: (id: number) => apiGet(`/PosReturn/Details?id=${id}`),
  getPosReturns: (payload: unknown) =>
    apiPost("/PosReturn/GetPosReturns", payload),

  // POS settings
  createOrUpdatePosSettings: (payload: unknown) =>
    apiPost("/possettings/CreateOrUpdate", payload),
  getPosSettings: () => apiGet("/possettings/details"),

  // Sales persons
  getActiveOutletSalesPersons: (outletId: number) =>
    apiGet(`/OutletSalePersonAssignment/GetActiveByOutlet?outletId=${outletId}`),

  // Warehouse
  getWarehouseById: (id: number) =>
    apiRequestBase<any>(env.inventoryBaseUrl, `/Warehouse/Details?id=${id}`, { method: "GET" }),
};
